import styled from "styled-components";

export const Wrapper = styled.main`
  max-width: 900px;
  padding: 20px;
  margin: 0 auto;
`;
